import React from "react";
import { queryOps, Query } from "system/query/Query";
import QueryBranchBuilder from "components/queries/queryBuilder/segments/branch/QueryBranchBuilder";
import QueryLeafNodeBuilder from "components/queries/queryBuilder/segments/leaf/QueryLeafNodeBuilder";
import { QueryInfo } from "system/query/QueryInfo";
import { queryOpIsLeafNode, segmentIsBranch } from "system/query/QueryUtility";
import { QuerySegment } from "system/query/QuerySegment";
import { QueryBranch } from "system/query/QueryBranch";
import { QuerySpan } from "system/query/QuerySpan";
import { QueryLeafNode } from "system/query/QueryLeafNode";
import QueryBranchViewer from "../segments/branch/QueryBranchViewer";
import QuerySpanViewer from "../segments/span/QuerySpanViewer";
import QuerySpanBuilder from "../segments/span/QuerySpanBuilder";

export enum spanSide {
  left = "left",
  right = "right"
}

export interface QuerySegmentProps {
  querySegment: QuerySegment;
  path: string;
  depth: number;
  parent?: QuerySegment | Query;
  isAddingActive?: boolean;
  inSpan?: boolean;
  spanSide?: spanSide;
  queryInfo: QueryInfo;
  isViewerMode?: boolean;
  editSegment: (segment:QuerySegment, parent:QuerySegment | Query | undefined, inSpan?:boolean, spanSide?:spanSide) => void;
  addSegment: (parent:QuerySegment | Query | undefined, inSpan?:boolean, spanSide?:spanSide) => void;
}

export default function QuerySegmentContainer(props: QuerySegmentProps): JSX.Element {
  const querySegment = props.querySegment;

  const isBranch:boolean = segmentIsBranch(querySegment),
      isLeafNode:boolean = !querySegment.op || queryOpIsLeafNode(querySegment.op),
      common = {
        parent: props.parent,
        path: props.path,
        isAddingActive: props.isAddingActive,
        inSpan: props.inSpan,
        spanSide: props.spanSide,
        queryInfo: props.queryInfo,
        depth: props.depth + 1,
        editSegment: props.editSegment,
        addSegment: props.addSegment,
      };
  return (
    <>
      {isBranch && !props.isViewerMode &&
        <QueryBranchBuilder
          isViewerMode={props.isViewerMode}
          querySegment={querySegment}
          queryBranch={querySegment as QueryBranch}
          {...common} />
      }
      {isBranch && props.isViewerMode &&
        <QueryBranchViewer
          isViewerMode={props.isViewerMode}
          querySegment={querySegment}
          queryBranch={querySegment as QueryBranch}
          {...common} />
      }
      {querySegment.op === queryOps.span && props.isViewerMode &&
        <QuerySpanViewer
          isViewerMode={true}
          querySegment={querySegment}
          querySpan={querySegment as QuerySpan}
          {...common} />
      }
      {querySegment.op === queryOps.span && !props.isViewerMode &&
        <QuerySpanBuilder
          isViewerMode={false}
          querySegment={querySegment}
          querySpan={querySegment as QuerySpan}
          {...common} />
      }
      {isLeafNode &&
        <QueryLeafNodeBuilder
          isViewerMode={props.isViewerMode}
          querySegment={querySegment}
          queryLeafNode={querySegment as QueryLeafNode}
          {...common} />
      }
    </>
  );
}